//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinComponent from './mixinComponent.js'
export default {
  name: 'VyInputLookup',
  mixins: [mixinComponent],
  props: {
    params: Object, // lookup 参数列表
    fieldName: String, // 字段名
    value: [String, Number, Array, Boolean], // value需要双向绑定传递到组件外部
    text: String, // text需要双向绑定传递到组件外部

    title: String, // 标题
    placeholder: {type: String, default: '请选择'}, // 占位提示文字
    searchPlaceholder: String, // 搜索框占位提示文字
    required: {type: Boolean, default: false}, // 必填
    readonly: {type: Boolean, default: false}, // 只读
    disabled: {type: Boolean, default: false}, // 禁用
    hide: {type: Boolean, default: false}, // 隐藏
  },
  methods: {
    cellClick () {
      if(!this.disabled && !this.readonly) {
        this.$emit('vy-lookup-click', {
          title: this.title,
          key: this.fieldKey,
          value: this.value,
          params: this.params,
          searchPlaceholder: this.searchPlaceholder,
          fieldName: this.fieldName,
        })
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/basic/VyInputLookup.vue